import { render, staticRenderFns } from "./authpage.vue?vue&type=template&id=2fd4d82e&scoped=true"
import script from "./authpage.vue?vue&type=script&lang=js"
export * from "./authpage.vue?vue&type=script&lang=js"
import style0 from "./authpage.vue?vue&type=style&index=0&id=2fd4d82e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fd4d82e",
  null
  
)

export default component.exports